


import { Component, Vue, Watch } from 'vue-property-decorator';
import Cookies from 'js-cookie';
import { Route } from 'vue-router';

@Component
export default class App extends Vue {
	private static readonly KEY_NAME_LANG: string = 'lang';
	private isInitialized: boolean = false;

	private created() {
		if (this.isInitialized) {
			return;
		}

		// クエリから言語情報を取得する
		let lang: string = this.$route.query.lang as string;

		if ( ! lang ) {
			// 取得できなければクッキーから取得を試みる
			lang = Cookies.get(App.KEY_NAME_LANG) as string;
		}

		// 言語設定
		this.setLang(lang);


		const cookiePaths = [
			this.$store.state.apiPath,
			this.$store.state.basePath,
		];

		cookiePaths.forEach( (path) => {
			// クッキーにセットする
			Cookies.set(
				App.KEY_NAME_LANG,
				this.$store.state.lang,
				{
					sameSite: 'none',
					secure: true,
					expires: 365,
					path,
				},
			);
		});

		this.isInitialized = true;
	}

	private mounted()
	{
		// タイトル更新
		this.updatePageTitle(this.$route);
	}

	@Watch('$route')
	private onRouterChanged(to: Route, from: Route)
	{
		// タイトル更新
		this.updatePageTitle(to);
	}

  private setLang(lang: string) {
	// ロケールの設定
	if ( lang ) {
		this.$store.commit('setLang', { lang });
	}

	// HTML の lang 属性を新しいロケールに置き換える
	const html: HTMLElement = document.documentElement;
	html.setAttribute('lang', this.$store.state.lang);

	// ロケールを多言語切り替えモジュールに渡す
	this.$i18n.locale = this.$store.state.lang;
  }

	private updatePageTitle(to: Route)
	{
		// タイトルを設定
		const titleKey: string = to.name + '.title';
		if ( this.$te( titleKey ) )
		{
			document.title = '' + this.$t( titleKey ) + ' | PSOFT USER PAGE';
		}
		else
		{
			document.title = 'PSOFT USER PAGE';
		}

		// 説明文
		const descriptionKey: string = to.name + '.desc';
		if ( this.$te( descriptionKey ) )
		{
			const description = document.querySelector( 'meta[name=\'description\']' );
			if (description)
			{
				description.setAttribute( 'content', '' + this.$t( descriptionKey ) );
			}
		}
	}
}
